/*eslint-disable */
const $ = window.jQuery = require('jquery');

import countries from '@/services/country.json';
import toast from '@/services/toast';

export default {
  name: 'abscond-list',
  components: {},
  props: [],
  data () {
    return {
      lStaffData:null,
      lStaffDataResults:[],
      nextPageUrl:'',
      nextStep:'',
      totalCountOfUsers:null,
      countryList:[],
      removeUserId:'',
      removeUserFromOurList:false
    }
  },
  computed: {

  },
  mounted () {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    this.getLymphomapUserListsFunc()
  },
  methods: {
    getLymphomapUserListsFunc() {
      this.$store.dispatch('geEmployeeLisOfFiltertFun', {id:'abscond'}).then((res) => {
        this.lStaffData = res.data 
        this.lStaffDataResults = this.lStaffData.data 
      })
    },
    showRemovedModalFun(id){
      $("body").addClass("body_right_scroll_remove");
      this.removeUserFromOurList = true
      this.removeUserId = id
      $(window).scrollTop(0);
    },
    removeModalItemConfirmFun(){
      this.$store.dispatch('removeSaOrgUserFun', {
        id: this.removeUserId,
      })
      .then((res) => {
        if (res.status == '200') {      
          toast.success(res.data.msg); 
          $("body").removeClass("body_right_scroll_remove");
          this.removeUserFromOurList = false
          this.removeUserId = ''
          this.getLymphomapUserListsFunc()
        }
      }).catch((err) => {
        toast.error(err.data.user_msg);  
      })
    return;
    },
    closeRemoveItemModalFun(){
      $("body").removeClass("body_right_scroll_remove");
      this.removeUserFromOurList = false
      this.taskDeleteId = ''
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/shiny/${country.value}.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
  }
}